import styled, { css, keyframes } from 'styled-components';

export interface StyleProps {
  isErrored?: boolean;
  formLook?: boolean;
}

const animValid = keyframes`
  from{
    transform: translateY(20px);
    opacity: 0;
  }to{
    transform: translateY(0);
    opacity: 1;
  }
`;

export const Container = styled.div<StyleProps>`
  border: 1px solid ${(props) => props.theme.colors.text.secondary};
  box-sizing: border-box;
  border-radius: 10px;
  position: relative;
  width: 100%;
  flex: 1;
  padding: 15px 20px;
  display: flex;
  background: white;

  flex-wrap: wrap;
  gap: 0.5rem;

  ${(props) =>
    props.formLook &&
    css`
      padding: 8px 10px;
      border-radius: 5px;
      border-color: ${props.theme.colors.palet.institutional12};
    `}

  ${(props) =>
    props.isErrored &&
    css`
      border-color: ${props.theme.colors.palet.institutional7};
    `}
`;

export const CustomInput = styled.input<Pick<StyleProps, 'formLook'>>`
  border: none;
  outline: none;
  flex: 1 0 100px;

  font-family: 'Unimed-Sans-SemiBold';
  ${(props) =>
    props.formLook &&
    css`
      font-family: 'Unimed-Sans-Book';
      color: ${props.theme.colors.palet.institutional11};
    `}
`;

export const Tag = styled.div<Pick<StyleProps, 'formLook'>>`
  font-family: 'Unimed-Sans-SemiBold';
  ${(props) =>
    props.formLook &&
    css`
      font-family: 'Unimed-Sans-Book';
      color: ${props.theme.colors.palet.institutional11};
    `}

  background: ${(props) => props.theme.colors.palet.institutional3};
  color: ${(props) => props.theme.colors.text.whiteToBlack};
  padding: 0px 0.5rem;
  border-radius: 2px;
  display: flex;
  gap: 0.5rem;
  align-items: center;

  button {
    border: none;
    outline: none;
    display: flex;
    justify-content: center;
    align-items: center;

    background: transparent;
    color: ${(props) => props.theme.colors.text.whiteToBlack};
  }
`;
